import React from "react";
import { Link } from "react-router-dom";

export function Med900Logo({ size = "text-xl", className = "", asLink = false }) {
  const logo = (
    <div
      className={`med900-logo ${size} ${className}`}
      data-testid="med900-logo"
    >
      <span className="med900-logo-med">Med</span>
      <span className="med900-logo-900">900</span>
      <span className="med900-logo-dot">.</span>
    </div>
  );

  if (asLink) {
    return (
      <Link to="/" className="inline-block">
        {logo}
      </Link>
    );
  }

  return logo;
}
